/**
 * Simple file processor that doesn't rely on external libraries
 * Use this as a fallback when the main file processor fails
 */

// Read a file as text
export const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result)
      reader.onerror = (e) => reject(e.target.error)
      reader.readAsText(file)
    })
  }
  
  // Read a file as data URL
  export const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result)
      reader.onerror = (e) => reject(e.target.error)
      reader.readAsDataURL(file)
    })
  }
  
  // Process a file based on its type
  export const processFile = async (file) => {
    try {
      // Handle different file types
      if (file.type.startsWith("image/")) {
        // For images, return a data URL
        return {
          type: "image",
          content: await readFileAsDataURL(file),
          name: file.name,
        }
      } else if (file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")) {
        // For PDFs, return a placeholder message
        return {
          type: "pdf",
          content: `[PDF content from ${file.name} - Please install PDF.js for full text extraction]`,
          name: file.name,
        }
      } else if (
        file.type.includes("spreadsheet") ||
        file.type.includes("excel") ||
        file.name.toLowerCase().endsWith(".xlsx") ||
        file.name.toLowerCase().endsWith(".xls")
      ) {
        // For Excel files, return a placeholder message
        return {
          type: "spreadsheet",
          content: `[Spreadsheet data from ${file.name} - Please install SheetJS for full data extraction]`,
          name: file.name,
        }
      } else if (
        file.type.includes("document") ||
        file.type.includes("word") ||
        file.name.toLowerCase().endsWith(".docx") ||
        file.name.toLowerCase().endsWith(".doc")
      ) {
        // For Word documents, return a placeholder message
        return {
          type: "document",
          content: `[Document content from ${file.name} - Please install mammoth.js for full text extraction]`,
          name: file.name,
        }
      } else if (file.type.startsWith("text/")) {
        // For text files, read as text
        return {
          type: "text",
          content: await readFileAsText(file),
          name: file.name,
        }
      } else {
        // For other file types, try to read as text, but it might not work
        try {
          return {
            type: "unknown",
            content: await readFileAsText(file),
            name: file.name,
          }
        } catch (error) {
          return {
            type: "unknown",
            content: `[File ${file.name} could not be processed]`,
            name: file.name,
          }
        }
      }
    } catch (error) {
      console.error("Error processing file:", error)
      return {
        type: "error",
        content: `Error processing file: ${error.message}`,
        name: file.name,
      }
    }
  }
  
  // Process multiple files
  export const processFiles = async (files) => {
    const results = []
    for (const file of files) {
      results.push(await processFile(file))
    }
    return results
  }
  